
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notification, } from 'antd';

import { removeAlert, selectAlerts } from "reducers/alertSlice";

function NotificationBar(props) {
    let dispatch = useDispatch();
    let alerts = useSelector(selectAlerts);

    const cancelAlert = useCallback((id) => dispatch(removeAlert(id)), [dispatch]);

    const [api, contextHolder] = notification.useNotification({
        maxCount: 6,
        stack: {
            threshold: 6
        }
    });
    useEffect(() => {
        alerts.forEach(({ type, message, description, delay, id, href, onClickStorageKey }) => {
            if (!Object.keys(api).includes(type)) {
                // console.error("Invalid type: ", type);
                return;
            }

            const isExternal = href ? /^https?:\/\//i.test(href) : false;

            // 🚀 Daca notificarea are un onClickStorageKey, la click marcam permanent
            // in localStorage - util pt. "nu mai arata dupa ce a apasat" (ex: review).
            const markClicked = () => {
                if (!onClickStorageKey) return;
                try {
                    localStorage.setItem(onClickStorageKey, "true");
                } catch {
                    // ignoram - cel mult mai apare o data
                }
            };

            const goToHref = () => {
                markClicked();
                // Link extern (ex: recenzie Google) -> tab nou, ca sa nu pierdem
                // sesiunea/pagina curenta din aplicatie.
                if (isExternal) {
                    window.open(href, "_blank", "noopener,noreferrer");
                } else {
                    window.location.assign(href);
                }
            };

            // 🚀 In loc sa ne bazam doar pe onClick pe tot corpul notificarii (poate
            // fi blocat de un popup-blocker sau ratat daca userul da click pe X),
            // punem un link <a> real, nativ - garantat clickabil, indiferent de wiring.
            const descriptionNode = href ? (
                <>
                    {description}
                    <div style={{ marginTop: 8 }}>
                        <a
                            href={href}
                            target={isExternal ? "_blank" : undefined}
                            rel={isExternal ? "noopener noreferrer" : undefined}
                            onClick={(e) => {
                                e.stopPropagation();
                                markClicked();
                            }}
                        >
                            Deschide link-ul →
                        </a>
                    </div>
                </>
            ) : description;

            api[type]({
                title: message,
                description: descriptionNode,
                duration: delay,
                key: id,
                className: "notification-item",
                style: {
                    width: 600,
                    cursor: href ? "pointer" : "default",
                },
                onClick: href ? goToHref : undefined,
                onClose: () => cancelAlert(id)
            })
        })
        // console.log("alerts from .", alerts)
    }, [alerts, api, cancelAlert]);

    return contextHolder;
}

export default NotificationBar;
